import {
	Flex,
	Text,
	Icon,
	Card,
	Tooltip,
	Checkbox,
	Button,
} from 'src/components/ui';
import {
	RiRefreshLine,
	RiEdit2Line,
	RiDeleteBin7Line,
	RiLockUnlockLine,
	RiLockLine,
	RiFileCopyLine,
	RiVideoAddLine,
} from 'react-icons/ri';

interface CardActionsProps {
	title: string;
	onEdit?: () => void;
	onRemove?: () => void;
	onRegenerate?: () => Promise<void>;
	onCopy?: () => void;
	onLock?: () => void;
	onImportVideoAd?: () => void;
	isSelected?: boolean;
	disabledActions?: boolean;
	isLocked?: boolean;
	onSelectChange?: (isSelected: boolean) => void;
	showCheckbox?: boolean;
	borderRadiusValues?: string;
	mb?: string;
}

const CardActions = ({
	title,
	onEdit,
	onRegenerate,
	onRemove,
	onCopy,
	onLock,
	onImportVideoAd,
	isSelected = false,
	disabledActions,
	isLocked,
	onSelectChange,
	showCheckbox = false,
	borderRadiusValues = '10px',
	mb = '0px',
}: CardActionsProps) => {
	const disabledStyles = {
		opacity: 0.4,
		cursor: 'not-allowed',
	};

	return (
		<Card
			boxShadow="md"
			maxH="sm"
			borderRadius={borderRadiusValues}
			bg={isLocked ? 'gray.200' : isSelected ? '#F75A23' : 'white'}
			py={0.5}
			mb={mb}
		>
			<Flex
				px={{ base: 2, md: 4 }}
				py={0.5}
				justifyContent="space-between"
				alignItems="center"
				color={isSelected ? 'white' : 'black'}
			>
				<Flex alignItems="center" minW={0} flex="0 1 auto">
					{/* {showCheckbox && (
            <Checkbox
              isChecked={isSelected}
              onChange={(e) => onSelectChange?.(e.target.checked)}
              mr={2}
              sx={{
                '& .chakra-checkbox__control': {
                  bg: 'white',
                  borderColor: 'gray.200',
                },
                '& .chakra-checkbox__control[data-checked]': {
                  bg: 'white',
                  borderColor: 'white',
                  color: '#F75A23',
                },
              }}
            />
          )} */}
					<Text
						size={{ base: 'sm', md: 'md' }}
						color={isSelected ? 'white !important' : 'black'}
						whiteSpace="nowrap"
						overflow="hidden"
						textOverflow="ellipsis"
						fontWeight={isSelected ? '600' : '500'}
					>
						{title}
					</Text>
				</Flex>
				<Flex gap={{ base: 1, md: 3 }} mb={-1} flexShrink={0}>
					{onImportVideoAd && (
						<Button
							data-testid="import-video-ad-btn"
							display="flex"
							p={{ base: 1, md: 2 }}
							minW="auto"
							leftIcon={<RiVideoAddLine size={18} />}
							justifyContent="left"
							variant="unstyled"
							onClick={!disabledActions ? onImportVideoAd : undefined}
							cursor={disabledActions ? 'not-allowed' : 'pointer'}
							color={isSelected ? 'white' : 'black'}
							fontWeight={500}
							{...(disabledActions && disabledStyles)}
						>
							<Text
								color={isSelected ? 'white' : 'black'}
								display={{ base: 'none', md: 'block' }}
							>
								Import Video
							</Text>
						</Button>
					)}

					{onEdit && !onImportVideoAd && (
						<Button
							data-testid="edit-btn"
							display="flex"
							p={{ base: 1, md: 2 }}
							minW="auto"
							leftIcon={<RiEdit2Line size={18} />}
							justifyContent="left"
							variant="unstyled"
							onClick={!disabledActions ? onEdit : undefined}
							cursor={disabledActions ? 'not-allowed' : 'pointer'}
							color={isSelected ? 'white' : 'black'}
							fontWeight={500}
							{...(disabledActions && disabledStyles)}
						>
							<Text
								color={isSelected ? 'white' : 'black'}
								display={{ base: 'none', md: 'block' }}
							>
								Edit
							</Text>
						</Button>
					)}

					{onRegenerate && (
						<Button
							data-testid="regenerate-btn"
							display="flex"
							p={{ base: 1, md: 2 }}
							minW="auto"
							onClick={!disabledActions ? onRegenerate : undefined}
							leftIcon={<RiRefreshLine size={18} />}
							justifyContent="left"
							variant="unstyled"
							cursor={disabledActions ? 'not-allowed' : 'pointer'}
							fontWeight={500}
							color={isSelected ? 'white' : 'black'}
							{...(disabledActions && disabledStyles)}
						>
							<Text
								color={isSelected ? 'white' : 'black'}
								display={{ base: 'none', md: 'block' }}
							>
								Regenerate
							</Text>
						</Button>
					)}
					{onCopy && (
						<Button
							data-testid="copy-btn"
							display="flex"
							p={{ base: 1, md: 2 }}
							minW="auto"
							onClick={onCopy}
							leftIcon={<RiFileCopyLine size={18} />}
							justifyContent="left"
							variant="unstyled"
							cursor="pointer"
							fontWeight={500}
							color={isSelected ? 'white' : 'black'}
						>
							<Text
								color={isSelected ? 'white' : 'black'}
								display={{ base: 'none', md: 'block' }}
							>
								Copy
							</Text>
						</Button>
					)}
					{onRemove && (
						<Button
							data-testid="remove-btn"
							display="flex"
							p={{ base: 1, md: 2 }}
							minW="auto"
							onClick={onRemove}
							leftIcon={<RiDeleteBin7Line size={18} />}
							justifyContent="left"
							variant="unstyled"
							color={isSelected ? 'white' : 'black'}
							fontWeight={500}
						>
							<Text
								color={isSelected ? 'white' : 'black'}
								display={{ base: 'none', md: 'block' }}
							>
								Remove
							</Text>
						</Button>
					)}
					{onLock && (
						<Tooltip
							label={isLocked ? 'Unlock' : 'Lock'}
							px={3}
							borderRadius={100}
						>
							<span data-testid="lock-icon">
								<Icon
									onClick={onLock}
									as={isLocked ? RiLockLine : RiLockUnlockLine}
									boxSize={5}
									cursor="pointer"
									color={isSelected ? 'white' : 'black'}
								/>
							</span>
						</Tooltip>
					)}
				</Flex>
			</Flex>
		</Card>
	);
};

export default CardActions;
